exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "img[data-v-4f0a9b77]{max-height:28px}span[data-v-4f0a9b77]{white-space:pre}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4f0a9b77","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/dialog/types/DialogNoMoreSpace.vue
// module id = 1037
// module chunks = 22